import Loadable from './Loadable.jsx';
import React from 'react';
import PropTypes from 'prop-types';

const LoadableTableBody = ({loading, numColumns, numRows, children, loadingClassesByColumn, ...props}) => {
  if (loading) {
    return (
      <tbody {...props}>
        {
          range(numRows).map(x => (
            <LoadingRow key={x} numColumns={numColumns} loadingClassesByColumn={loadingClassesByColumn} />
          ))
        }
      </tbody>
    );
  }
  else {
    return (
      <tbody {...props}>
        {children}
      </tbody>
    );
  }
};

const range = (n) => [...Array(n).keys()];

const LoadingRow = ({numColumns, loadingClassesByColumn={}}) => {
  const items = [];
  for (let i = 0; i < numColumns; i++) {
    let loadingClasses = loadingClassesByColumn[i] || ['row'];
    items.push(<td key={i}> <Loadable loading={true} loadingClasses={loadingClasses} /></td>);
  }

  return (
    <tr>
      {items}
    </tr>
  );
};

export { LoadingRow };

LoadableTableBody.propTypes = {
  numColumns: PropTypes.number.isRequired,
  numRows: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  loadingClassesByColumn: PropTypes.object,
  children: PropTypes.node
};

LoadableTableBody.defaultProps = {
  loadingClassesByColumn: {},
  numRows: 3,
};

export default LoadableTableBody;
